<div class="splash-screen">
  <img class="logo" src="/full-logo-black.svg" alt=""/>
</div>
